import { render, staticRenderFns } from "./CmgIngredientsLandingPage.vue?vue&type=template&id=03bd14ba&scoped=true&lang=pug"
import script from "./cmg-ingredients-landing-page.ts?vue&type=script&lang=ts&external"
export * from "./cmg-ingredients-landing-page.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgIngredientsLandingPage.vue?vue&type=style&index=0&id=03bd14ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bd14ba",
  null
  
)

export default component.exports